import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ModalContext from '../modal.context';
import { MotifIconButton } from '../../button/icon-button/icon-button';
import { ReactComponent as HardwareIcClose24px } from '../../../assets/icons/navigation/ic_close_24px.svg';

const defaultIcons = {
  close: <HardwareIcClose24px />
};

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} [className]
 * @prop {React.ReactNode} [closeModalButton]
 * @prop {{}} [closeButtonProps]
 * @prop {{close: React.ReactNode}} [icons]
 */
/**
 * @param {Props & {[x: string]: any;}} props
 */
const MotifModalHeader = (props) => {
  const {
    children,
    className = '',
    closeModalButton = null,
    closeButtonProps = {},
    icons: userIcons = {},
    ...other
  } = props;
  const icons = {
    ...defaultIcons,
    ...userIcons
  };
  const modal = useContext(ModalContext);

  const handleClick = () => {
    modal.closeModal();
  };

  const classes = classNames({
    'motif-modal-header': true,
    [className]: true
  });

  return (
    <div {...other} className={classes} data-motif-modal-header>
      <h3 className="motif-h3 motif-modal-headline">{children}</h3>

      {closeModalButton ? (
        <React.Fragment>{closeModalButton}</React.Fragment>
      ) : (
        <MotifIconButton
          aria-label="Click here to close modal"
          type="button"
          onClick={handleClick}
          className="motif-modal--header-icon-button"
          data-testid="close-modal"
          {...closeButtonProps}
        >
          {icons.close}
        </MotifIconButton>
      )}
    </div>
  );
};

MotifModalHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeModalButton: PropTypes.node,
  closeButtonProps: PropTypes.instanceOf(Object),
  icons: PropTypes.shape({
    close: PropTypes.node
  })
};

export { MotifModalHeader };
